import Navbar from "components/navbar/Navbar";
import CreateOrganization from "./CreateOrganization";

const CreateOrganizationPage: React.FC = () => (
  <>
    <Navbar />
    <div style={{ padding: "24px 0" }}>
      <CreateOrganization />
    </div>
  </>
);

export default CreateOrganizationPage;
